import {Directive,ElementRef,HostBinding,HostListener,Input} from '@angular/core';
import {DynamicDragClickInterceptorService} from "@share/component/list-view/dynamic-drag-click-interceptor.service";

/**
 * Directive pour l'interception du scroll 2D type cliquer-déplacer
 */
@Directive({
    selector: '[dynamicDragClickInterceptor]',
})
export class DynamicDragClickInterceptorDirective {
    /** Méthode à appeler lorsque le clic est actif */
    @Input() dynamicDragClickInterceptor: ()=> any;

    /**
     * Constructeur
     */
    constructor(public elementRef: ElementRef,private dynamicDragClickInterceptorService: DynamicDragClickInterceptorService) {}

    /**
     * Détection de la présence ou non de la classe CSS désactivant le drag
     */
    @HostBinding('class.no-drag-active')
    get isDragDisabled() {
        //True si l'élément contient la classe CSS
        return this.elementRef.nativeElement.classList.contains('drag-disabled');
    }

    /**
     * Clic
     */
    @HostListener('mousedown', ['$event'])
    onMouseDown(event: MouseEvent): void {
        //Annulation en cas de clic différent de gauche ou molette
        if (!(event.button === 0 || event.button === 1)) {
            event.preventDefault();
            return;
        }

        //Sauvegarde du statut du cliquer-déplacer (via la classe CSS)
        this.dynamicDragClickInterceptorService.isDragDisabled = this.isDragDisabled;

        //Si le blocage du cliquer-déplacer est activé par la présence de la classe CSS
        if (this.isDragDisabled) {
            //Empêche le déclenchement de la fonctionnalité de cliquer-déplacer
            event.stopPropagation();
            event.preventDefault();

            //Fin
            return;
        }

        //Mouvement en cours
        this.dynamicDragClickInterceptorService.isDragging = true;

        //Reset du flag de déplacement
        this.dynamicDragClickInterceptorService.isMoved = false;

        //Position de départ
        this.dynamicDragClickInterceptorService.startX = event.clientX;
        this.dynamicDragClickInterceptorService.startY = event.clientY;
    }

    /**
     * Mouvement
     */
    @HostListener('mousemove', ['$event'])
    onMouseMove(event: MouseEvent): void {
        //Annulation si aucun clic n'a eu lieu
        if (!this.dynamicDragClickInterceptorService.isDragging) return;

        //Calcul du déplacement
        const x = event.clientX - this.dynamicDragClickInterceptorService.startX;
        const y = event.clientY - this.dynamicDragClickInterceptorService.startY;

        //Si le déplacement est supérieur à 1 pixel
        if (Math.abs(x) > 1 || Math.abs(y) > 1) {
            //Marque qu'un déplacement a eu lieu
            this.dynamicDragClickInterceptorService.isMoved = true;
        }
    }

    /**
     * Relâchement du clic
     */
    @HostListener('mouseup', ['$event'])
    onMouseUp(event: MouseEvent): void {
        //Si la balise de départ du clic n'avait pas le clic désactivé ou que la souris n'a pas du tout bougé
        if (!this.dynamicDragClickInterceptorService.isMoved && event.button === 0) {
            //Exécution du clic
            this.dynamicDragClickInterceptor();
        } else {
            //Sinon interception du clic
            event.preventDefault();
        }

        //Fin du déplacement
        this.dynamicDragClickInterceptorService.isDragging = false;
        this.dynamicDragClickInterceptorService.isMoved = false;
    }
}
